import React, { MouseEventHandler } from "react";
import WelcomeModalImage from "../assets/welcomeModal.png";

export const WelcomeModal = ({
  onCloseModal,
}: {
  onCloseModal: MouseEventHandler<HTMLDivElement>;
}) => {
  return (
    <div className="relative z-10" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div className="fixed inset-0 bg-gray-500 bg-opacity-40 transition-opacity"></div>
      <div className="fixed inset-0 z-10 overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div
            onClick={onCloseModal}
            className="relative transform overflow-hidden text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-2xl min-w-[982px] rounded-[20px] cursor-pointer">
            <div>
              <img
                src={WelcomeModalImage}
                alt={"welcome-modal-septeo"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
